'use client';

import { useQuery } from '@tanstack/react-query';
import { getAgreements } from '../service';
import { Agreement } from '../types';

/**
 * Hook to fetch and manage user subscriptions (agreements)
 * @param jwt The JWT token for authentication
 * @returns Object containing the agreements data, loading state, and refetch function
 */
export const useAgreements = (jwt: string) => {
  const { data, isLoading, isFetching, refetch } = useQuery<Agreement[]>({
    queryKey: ['agreements', jwt],
    queryFn: () => {
      if (!jwt) {
        return [];
      }
      return getAgreements(jwt);
    },
    enabled: !!jwt,
  });

  return {
    agreements: data ?? [],
    loading: isLoading || isFetching,
    refetch,
  };
};

export default useAgreements;
